export { CARDS_PER_PAGE } from './cardsperpage';
